module.exports = __webpack_public_path__ + "img/service-edu1.a75651eb.svg";